export default __webpack_public_path__ + "static/media/logo_SMMP_.958c5e22.svg";